<template>
  <div class="aboutus">
    <div class="title">
      <el-divider content-position="center">個人經歷</el-divider>
      <p><el-tag>四川托普信息技术职业学院</el-tag><el-tag>专科</el-tag><br/><br/>
      <el-tag >成都货安计量技术中心</el-tag><el-tag>自由职业</el-tag><el-tag>广州品高软件股份有限公司</el-tag></p>
    </div>
    <div class='experience'>
      <el-timeline>
         <el-timeline-item timestamp="2009/09/-2012/06" placement="top">
          <el-card>
            <h4>四川托普信息技术职业学院</h4>
            <p>
              1.就讀於四川托普信息技术职业学院<br>
              2.進入學院軟件研究所<br>
              3.大二时以专业第一的成绩获得一等奖学金。<br>
            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2011/12/-2013/06" placement="top">
          <el-card>
            <h4>成都货安计量技术中心</h4>
            <h4>初级开发工程师</h4>
            <p>
              1.负责货運安全监控系统的开发,数据接口协调及开发，全國各個鐵路局实施、培训以及维护<br>
              2.货运信息平台的开发各項報表開發維護。<br>
              3.技術棧:<el-tag>Delphi</el-tag>,<el-tag>.net</el-tag>,<el-tag>Jquery</el-tag>,<el-tag>Sqlserver</el-tag>,<el-tag>Oracle</el-tag>,<el-tag>ADO.NET</el-tag>,<el-tag>WebService</el-tag><br>

            </p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2013/07-2014/09" placement="top">
          <el-card>
            <h4>广州品高软件股份有限公司</h4>
            <h4>中级开发工程师</h4>
            <p>
            1.主要负责模块的设计和开发以及运维。<br/>
            2.獨立設計開發小型管理系統。<br/>
            3.駐場客戶現場與客戶對接需求及開發<br/>
            4.技術棧:<el-tag>Sliverlight</el-tag>,<el-tag>.net</el-tag>,<el-tag>Java</el-tag>,<el-tag>Oracle</el-tag>,<el-tag>DB2</el-tag>,<el-tag>Bootstrap</el-tag>,<el-tag>Jquery</el-tag>,<el-tag>EasyUI</el-tag></p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2014/09-2015/12" placement="top">
          <el-card>
            <h4>自由职业</h4>
            <p>
            1.由于想提高学历，裸辞考研，最终还是失败告终<br/>
            2.独立承接私活開發，主要為一些管理類系統，包括B/S和C/S<br/>
            3.技術棧:<el-tag>EasyUI</el-tag>,<el-tag>Sqlserver</el-tag>,<el-tag>Oracle</el-tag>,<el-tag>C#</el-tag>,<el-tag>DevExpress</el-tag>,<el-tag>WebService</el-tag>,<el-tag>.net mvc</el-tag>,<el-tag>EntityFramework</el-tag></p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2015/12-至今" placement="top">
          <el-card>
            <h4>广州品高软件股份有限公司</h4>
            <h4>高级开发工程师</h4>
            <p>
              1.负责新项目的架构设计和搭建，负责服务器的架构设计、搭建和運維，负责核心难点技术攻克。<br/>
              2.負責老項目項目的維護以及Bug修改<br/>
              3.負責攀枝花移動大數據平台ETL搭建和維護。<br/>
              4.新技術預研，團隊技術分享,如:k8s，hadoop大数据生态圈等等。<br/>
              5.新產品探索<br/>
              6.技术栈:<el-tag>Spring boot</el-tag>,<el-tag>Mybatis</el-tag>,<el-tag>Mycat</el-tag>,<el-tag>Redis</el-tag>,<el-tag>mongodb</el-tag>,<el-tag>DB2</el-tag>,<el-tag>GBase</el-tag>,<el-tag>Hive</el-tag>,<el-tag>MySQL</el-tag>,<el-tag>.net core </el-tag>,<el-tag>MVC</el-tag>,<el-tag>Layui</el-tag>,<el-tag>Vue</el-tag>,<el-tag>HyBrid/Cordova</el-tag>,<el-tag>Docker</el-tag>,<el-tag>Nginx/Openresty</el-tag>,<el-tag>Centos</el-tag>等等</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
    
  </div>
</template>
<script>
export default {
  name: 'About'
}
</script>
<style>
  .aboutus .grid-content.line{
    border-right: 1px solid #ddd;
    height: 150px;
  }
  .aboutus .el-card__header{
    background: #545c64;
  }
  .aboutus .el-card__body{
    padding: 50px 20px;
  }
  .aboutus .el-timeline-item__wrapper{
    top: -8px;
  }
  .aboutus .title p .el-tag{
    margin: 0px 5px;
    cursor: pointer;
  }
</style>
<style scoped>
  
  @media screen and (min-width: 400px) and (max-width: 768px) {
  .aboutus{
    font-size: 14px;
    text-align: left;
    padding: 0px 20px;
  }
}
@media screen and (min-width: 1024px) {
  .aboutus{
    font-size: 14px;
    text-align: left;
    padding: 0px 100px;
  }
}
  .intro{
    width: 200px;
    border: 1px solid #ddd;
    border-radius: 5px;
  }
  .text {
    font-size: 14px;
    text-align: left;
    line-height: 30px;
    text-indent: 2em;
  }
  .box-card{
    position: relative;
  }
  .item {
    display: inline-block;
    margin: 30px 50px;
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }
  .clearfix span{
    color: #fff;
    font-weight: bold;
  }
  .title p{
    color: #8c8888;
    font-size: 15px;
    margin-bottom: 80px;
    text-align: center;
  }
  .grid-content .large{
    font-size: 16px;
    color: #409EFF;
    font-weight: bold;
  }
  .topMask{
    width: 100px;
    height: 100px;
    background-color: rgba(68,138,255,0.2);
    transform: rotate(45deg);
    position: absolute;
  }
  .square{
    border-radius: 5px;
    top: 0px;
  }
  .circular{
    border-radius: 50%;
    top:80px;
    left: 80%;
    background-color: rgba(255, 208, 75,0.2);
  }
</style>


// WEBPACK FOOTER //
// src/components/about/About.vue